<template>
    <footer class="footer" v-if="setup != null" id="footer">
        <div class="container">
            <div class="inner-content">
                <div class="logo-bcn-footer">
                    <router-link to="/">
                        <img :src="setup.logo_bcn_footer" alt="">
                    </router-link>
                </div>
                <div class="footer-map">
                    <img :src="setup.map_footer" alt="">
                </div>
                <div class="footer-info">
                    <div class="social-links">
                        <strong>
                            <span v-if="globalLang == ''">Если есть вопросы, напишите нам</span>
                            <span v-if="globalLang == 'kz/'">Егер сұрақтар туындаса, бізге жазыңыз</span>
                            <span v-if="globalLang == 'en/'">If you have any questions, contact us</span>
                        </strong>
                        <div class="items">
                            <div class="link-item">
                                <a href="https://www.instagram.com/bcn_group?igsh=aWNxejcwaThhcDhl" target="_blank"><svgIcon name="instagram" class="icon-instagram"/></a>
                            </div>
                            <div class="link-item">
                                <a href=" https://www.facebook.com/share/16NVbm1ptr/" target="_blank"><svgIcon name="facebook" class="icon-facebook"/></a>
                            </div>
                        </div>
                    </div>
                    <div class="copy">
                        <p>{{setup.copyright}}</p>
                    </div>
                    <!-- <div class="made-in">
                        <p>Developed by</p>
                        <a href="https://v-web.kz" target="_blank">Victory WEB</a>
                    </div> -->
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import {mapGetters} from 'vuex'
    // import formFooterMail from '@/components/forms/form-footer-mail.vue';
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'AppFooter',
        data () {
            return {
                globalLang: window.GlobalLang, 
            }
        },
        components: {
            // formFooterMail,
            svgIcon
        },
        methods: {
            startLoader() {
                this.$parent.$refs.topProgress.start();
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
        }),
        created() {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/footer/footer.scss';
    @import '@/styles/components/footer/footer-respond.scss';
    // @import '@/styles/respond/footer/respond-footer.scss';
</style>